// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.store-label {
  background-color: white;
  border: 1px solid #ccc;
  padding: 3px 6px;
  font-size: 20px;
  font-weight: bold;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.app-footer {
  background-color: #333;
  color: white;
  text-align: center;
  padding: 1rem;
}

.loading {
  text-align: center;
  font-size: 1.2rem;
  color: #666;
}

/* 로그인 컴포넌트 스타일 */
.login-container {
  background-color: white;
  border-radius: 8px;
  margin: auto;
  text-align: center;
}

.login-container h2 {
  color: #4285F4;
  margin-bottom: 1rem;
}

.login-container p {
  color: #666;
  margin-bottom: 2rem;
}

.google-login-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: #757575;
  border: 1px solid #dadce0;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.google-login-button:hover {
  background-color: #f1f3f4;
}

.google-login-button img {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

/* 메인 컴포넌트 스타일 */
.main-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.main-container h2 {
  color: #4285F4;
  margin-bottom: 1rem;
}

.search-container {
  display: flex;
  margin-bottom: 1rem;
}

.search-container input {
  flex: 1 1;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #dadce0;
  border-radius: 4px 0 0 4px;
}

.search-container button {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  background-color: #4285F4;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}

.map-container {
  height: 400px;
  background-color: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

.results-container {
  background-color: white;
  border-radius: 4px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C","sourcesContent":[".App {\n  text-align: center;\n}\n\n.store-label {\n  background-color: white;\n  border: 1px solid #ccc;\n  padding: 3px 6px;\n  font-size: 20px;\n  font-weight: bold;\n  white-space: nowrap;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.app {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.app-footer {\n  background-color: #333;\n  color: white;\n  text-align: center;\n  padding: 1rem;\n}\n\n.loading {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #666;\n}\n\n/* 로그인 컴포넌트 스타일 */\n.login-container {\n  background-color: white;\n  border-radius: 8px;\n  margin: auto;\n  text-align: center;\n}\n\n.login-container h2 {\n  color: #4285F4;\n  margin-bottom: 1rem;\n}\n\n.login-container p {\n  color: #666;\n  margin-bottom: 2rem;\n}\n\n.google-login-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  color: #757575;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.google-login-button:hover {\n  background-color: #f1f3f4;\n}\n\n.google-login-button img {\n  width: 18px;\n  height: 18px;\n  margin-right: 10px;\n}\n\n/* 메인 컴포넌트 스타일 */\n.main-container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.main-container h2 {\n  color: #4285F4;\n  margin-bottom: 1rem;\n}\n\n.search-container {\n  display: flex;\n  margin-bottom: 1rem;\n}\n\n.search-container input {\n  flex: 1;\n  padding: 0.5rem;\n  font-size: 1rem;\n  border: 1px solid #dadce0;\n  border-radius: 4px 0 0 4px;\n}\n\n.search-container button {\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  background-color: #4285F4;\n  color: white;\n  border: none;\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n}\n\n.map-container {\n  height: 400px;\n  background-color: #e0e0e0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.results-container {\n  background-color: white;\n  border-radius: 4px;\n  padding: 1rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
